import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import access from '../../../../utils/access'

import style from '../../style'
import GroupTable from '../../partials/GroupTable'
import Container from '../../partials/Container'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('User', 'Auth', 'Config')
@observer
export class UserGroups extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        enabled: false
      },
      active: {}
    }
  }

  componentWillMount () {
    const _findGroupsLoop = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending) {
          return _findGroupsLoop()
        }

        this.props.User.getAllGroups()
      }, 500)
    }

    _findGroupsLoop()
  }

  onCreateClick (e) {
    e.preventDefault()
    return this.props.history.push(`${this.props.location.pathname}/new`)
  }

  onGroupExpand (index) {
    if (this.state.editor.enabled) {
      return this.props.history.push(`${this.props.location.pathname}/${index}`)
    }

    this.setState({
      ...this.state,
      active: {
        ...this.state.active,
        id: this.state.active.id === index ? null : index
      }
    })
  }

  onGroupEditClick () {
    if (this.state.active.id) {
      return this.props.history.push(
        `${this.props.location.pathname}/${this.state.active.id}`
      )
    }

    this.setState({
      ...this.state,
      active: {
        ...this.state.active,
        id: null
      },
      editor: {
        ...this.state.editor,
        enabled: !this.state.editor.enabled
      }
    })
  }

  render () {
    return (
      <Container
        {...this.props}
        hide={!access.modUser(this.props.User.me.permissions || {})}
      >
        <Row>
          <Col>
            <Row>
              <Col xs='12' lg='6'>
                <h2 className={css(style.headers.h2)}>User Groups</h2>
              </Col>
              <Col>
                <Row>
                  <Col>
                    <span
                      className={css(
                        style.buttons.button,
                        style.buttons.red,
                        this.state.editor.enabled
                          ? style.buttons.redActive
                          : null
                      )}
                      onClick={this.onGroupEditClick.bind(this)}
                    >
                      Edit
                    </span>
                  </Col>
                  <Col>
                    <span
                      className={css(style.buttons.button, style.buttons.red)}
                      onClick={this.onCreateClick.bind(this)}
                    >
                      Add new
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <GroupTable
            theme={THEME_LIST[this.props.Config.theme]}
            groups={this.props.User.groups.slice()}
            users={this.props.User.all.slice()}
            activeGroup={this.state.active}
            onGroupExpand={this.onGroupExpand.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

export default UserGroups



// WEBPACK FOOTER //
// ./src/components/User/Group/Main/index.js